      <template>
        <div>
          <!--            <canvas-->
          <div id="myChart" :style="{width: '100%', height: '215px'}"></div>
        </div>
      </template>

      <script>
      import * as echarts from 'echarts';
      // import * as  echarts from 'echarts'

      export default {
        name: "chart_line_two",
        props: [
          'yaxis',
          'xaxis',
        ],
        methods: {
          drawLine() {
            var myChartLine = echarts.init(document.getElementById('myChart'));
            var optionLine = {
              tooltip: {
                trigger: 'axis',
                showContent: false,
                axisPointer: {
                  type: 'cross',
                  label: {
                    backgroundColor: '#7B7B7B'
                  }
                }
              },
              xAxis: {
                type: 'category',
                scale: true,
                axisTick: {       //x轴刻度线是否显示
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    // 设置x轴颜色
                    color: '#7B7B7B',
                    width: 0, //x轴 是否显示
                    type: 'dotted', //'dotted'虚线 'solid'实线
                  }
                },
                // 设置X轴数据旋转倾斜
                boundaryGap: true,
                data: this.yaxis, //日期数据源
              },
              yAxis: {
                type: 'value',
                axisTick: {       //y轴刻度线是否显示
                  show: false
                },
                //设置分割线的颜色
                splitLine: {
                  lineStyle: {
                    type: "dashed",
                    color: "#DEDEDE"
                  }
                },
                axisLine: {
                  lineStyle: {
                    // 设置y轴颜色
                    color: '#7B7B7B',
                    width: 0, //y轴 是否显示
                    fontSize: 12,
                  }
                },
              },
              //边距调整
              grid: {
                x: 50,
                x2: 10,
                // y: 12,
                y: 30,
              },
              series: [
                {
                  data: this.xaxis, //总数数据源,6
                  type: 'line',
                  smooth: true,
                  seriesLayoutBy: 'row',
                  // 设置折线上圆点大小
                  symbolSize: 8,
                  areaStyle: {  //覆盖区域的渐变色
                    normal: {
                      // color: '#091e3b', //改变区域颜色
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0, color: '#3772ff' // 0% 处的颜色
                          }, {
                            offset: 1, color: '#fff' // 100% 处的颜色
                          }]
                      ),  //背景渐变色
                    }
                  },
                  showSymbol: false,//是否默认展示圆点
                  itemStyle: {
                    normal: {
                      label: {
                        show: false
                      }, // 拐点上显示数值
                      color: '#3772ff',
                      borderColor: '#3772ff', // 拐点边框颜色
                      lineStyle: {
                        width: 2, // 设置线宽
                        type: 'solid' //'dotted'虚线 'solid'实线
                      }
                    },
                    emphasis: { // 鼠标经过时：
                      label: {
                        show: true
                      },
                      borderColor: '#000', // 拐点边框颜色
                      color: "#fff",
                      lineStyle: {
                        width: 2, // 设置线宽
                        type: 'solid' //'dotted'虚线 'solid'实线
                      }
                    }
                  } //拐点设置
                }],
            };
            //为echarts对象加载数据
            myChartLine.setOption(optionLine);
            // console.log('yaxis',yaxis)
          }
        },
        mounted() {
          this.drawLine()
        }
      }
      </script>

      <style scoped>


      </style>
